"use strict";
/*
 * Created on 13. 12. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * DTO for pricelist row and pricelist.
 *
 * @author Radek Beran
 */


var PriceListRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceListRowDTO, _DomainObject_1$Domai);

  // NOTE: Extend this class if it is useful

  /**
   * Creates new price list DTO.
   * @param productId id of product
   * @param groupOfSiteId GOS where the price is valid
   * @param priceCodeId id of price code
   * @param priceCodeTitle title of price code
   * @param priceListTypeId id of price list type
   * @param priceListTypeTitle title of price list type
   * @param value price of the product
   */
  function PriceListRowDTO(productId, groupOfSiteId, priceCodeId, priceCodeTitle, priceListTypeId, priceListTypeTitle, value) {
    var _this;

    _classCallCheck(this, PriceListRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceListRowDTO).call(this));
    _this.productId = productId;
    _this.groupOfSiteId = groupOfSiteId;
    _this.priceCodeId = priceCodeId;
    _this.priceCodeTitle = priceCodeTitle;
    _this.priceListTypeId = priceListTypeId;
    _this.priceListTypeTitle = priceListTypeTitle;
    _this.value = value;
    return _this;
  }

  return PriceListRowDTO;
}(DomainObject_1.DomainObject);

exports.PriceListRowDTO = PriceListRowDTO;